import { Injectable } from '@angular/core';


export class UrlService {
  private instance = null;
  constructor() {
    if (sessionStorage.getItem('planner_lastListOrBoardUrl') === null) {
      sessionStorage.setItem('planner_lastListOrBoardUrl', '');
    }
  }

  recordLastListOrBoard(url) {
    sessionStorage.setItem('planner_lastListOrBoardUrl', url);
  }

  getLastListOrBoard() {
    return sessionStorage.getItem('planner_lastListOrBoardUrl');
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/** @nocollapse */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
